import {
  CreateDataRoomShareableLinkPayload,
  DataRoomShareableLink,
  DataRoomShareableLinkRequest,
  DataRoomShareableLinkReport,
  DataRoomShareableLinkNodeReport,
} from 'models/ShareableLink';
import httpClient from '../httpClient';
import { PaginatedData, PaginationParams } from 'models/PaginatedData';
import { DataRoomAnalytics } from '../../models/DataRoomNode';

function createShareableLink(
  dataRoomId: string,
  data: CreateDataRoomShareableLinkPayload & {
    dataRoomShareableLinkRequestId?: string;
  },
) {
  return httpClient.post<{
    dataRoomShareableLink: DataRoomShareableLink;
    dataRoomShareableLinkRequestId?: string;
  }>(`shareable-links/data-rooms/${dataRoomId}`, data);
}

function getShareableLinks(dataRoomId: string, params: PaginationParams) {
  return httpClient.get<PaginatedData<DataRoomShareableLink>>(
    `shareable-links/data-rooms/${dataRoomId}`,
    { params },
  );
}

function changeShareableLinkState(shareableLinkId: string, isActive: boolean) {
  return httpClient.post<DataRoomShareableLink>(
    `shareable-links/${shareableLinkId}/change-state`,
    {
      isActive,
    },
  );
}

function patchShareableLink(
  shareableLinkId: string,
  data: Partial<CreateDataRoomShareableLinkPayload>,
) {
  return httpClient.patch<DataRoomShareableLink>(
    `shareable-links/${shareableLinkId}`,
    data,
  );
}

function getWaitingRoom(dataRoomId: string, params?: PaginationParams) {
  return httpClient.get<PaginatedData<DataRoomShareableLinkRequest>>(
    `shareable-links/data-rooms/${dataRoomId}/waiting-room`,
    { params },
  );
}

function getWaitingRoomExpired(dataRoomId: string, params?: PaginationParams) {
  return httpClient.get<PaginatedData<DataRoomShareableLinkRequest>>(
    `shareable-links/data-rooms/${dataRoomId}/waiting-room-expired`,
    { params },
  );
}

function getDataRoomNodes(shareableLinkId: string, params: PaginationParams) {
  return httpClient.get<PaginatedData<DataRoomShareableLinkNodeReport>>(
    `shareable-links/${shareableLinkId}/files-analytics`,
    { params },
  );
}

function grantAccess(requestId: string) {
  return httpClient.post(`shareable-link-requests/${requestId}/approve-access`);
}

function rejectAccess(requestId: string) {
  return httpClient.post(`shareable-link-requests/${requestId}/reject-access`);
}

function ignore(requestId: string) {
  return httpClient.post(`shareable-link-requests/${requestId}/ignore`);
}

function getDataRoomNodeAnalytics(
  shareableLinkId: string,
  dataRoomNodeId: string,
  version: number,
) {
  return httpClient.get<DataRoomAnalytics[]>(
    `shareable-links/${shareableLinkId}/data-room-nodes/${dataRoomNodeId}/version/${version}`,
  );
}

function getShareableLinkReports(
  shareableLinkId: string,
  params: PaginationParams,
) {
  return httpClient.get<PaginatedData<DataRoomShareableLinkReport>>(
    `shareable-links/${shareableLinkId}/activity-logs`,
    { params },
  );
}

export default {
  createShareableLink,
  getShareableLinks,
  changeShareableLinkState,
  patchShareableLink,
  getWaitingRoom,
  getWaitingRoomExpired,
  grantAccess,
  rejectAccess,
  ignore,
  getDataRoomNodes,
  getDataRoomNodeAnalytics,
  getShareableLinkReports,
};
